(function () {
  function initClinicalReview(root) {
    if (root.hasAttribute("data-clinical-review-ready")) return;
    root.setAttribute("data-clinical-review-ready", "true");
    var bodyEl = root.querySelector("[data-clinical-review-body]");
    var toggleBtn = root.querySelector("[data-clinical-review-toggle]");
    var labelEl = root.querySelector("[data-clinical-review-label]");
    var iconEl = root.querySelector("[data-clinical-review-icon]");
    if (!bodyEl || !toggleBtn) return;

    function applyExpanded(expanded) {
      root.setAttribute("data-expanded", expanded ? "true" : "false");
      toggleBtn.setAttribute("aria-expanded", expanded ? "true" : "false");
      if (labelEl) {
        labelEl.textContent = expanded ? "Show less" : "Read full article";
      }
      if (iconEl) {
        iconEl.textContent = expanded ? "expand_less" : "expand_more";
      }
    }
    toggleBtn.addEventListener("click", function () {
      var on = root.getAttribute("data-expanded") === "true";
      applyExpanded(!on);
    });
    applyExpanded(false);
  }

  document.querySelectorAll("[data-clinical-review]").forEach(initClinicalReview);
})();
(function () {
  var track = document.querySelector("[data-feedback-marquee-track]");
  if (track && !track.hasAttribute("data-marquee-ready")) {
    var originals = Array.prototype.slice.call(track.children);
    originals.forEach(function (item) {
      var clone = item.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      track.appendChild(clone);
    });
    track.setAttribute("data-marquee-ready", "true");
  }
})();
(function () {
  var header = document.getElementById("site-header");
  var hero = document.getElementById("hero");
  if (!header || !hero) return;
  function syncHeaderState() {
    var heroBottom = hero.getBoundingClientRect().bottom;
    var solidOffset = header.offsetHeight + 8;
    header.classList.toggle("header--solid", heroBottom <= solidOffset);
  }
  syncHeaderState();
  window.addEventListener("scroll", syncHeaderState, { passive: true });
  window.addEventListener("resize", syncHeaderState);
})();
(function () {
  var header = document.getElementById("site-header");
  var root = document.documentElement;
  if (!header || !root) return;

  var themeTargets = [
    { id: "hero", theme: "dark" },
    { id: "workflow", theme: "sage" },
    { id: "featured-products", theme: "dark" },
    { id: "ai-diagnostics", theme: "light" },
    { id: "data-security-module", theme: "dark" },
    { id: "feedback", theme: "light" },
    { id: "downloads", theme: "sage" },
    { id: "faq", theme: "dark" },
    { id: "contact-form", theme: "light" },
    { id: "copyright", theme: "sage" }
  ]
    .map(function (item) {
      var el = document.getElementById(item.id);
      return el ? { el: el, theme: item.theme } : null;
    })
    .filter(Boolean);

  if (!themeTargets.length) return;

  function syncNavTheme() {
    var probeY = window.scrollY + header.offsetHeight + 36;
    var visibleTargets = themeTargets
      .map(function (item) {
        if (!item.el.getClientRects().length) return null;
        return {
          el: item.el,
          theme: item.theme,
          top: item.el.getBoundingClientRect().top + window.scrollY
        };
      })
      .filter(Boolean)
      .sort(function (a, b) {
        return a.top - b.top;
      });
    var current = visibleTargets[0] || themeTargets[0];
    visibleTargets.forEach(function (item) {
      if (probeY >= item.top) {
        current = item;
      }
    });
    root.setAttribute("data-nav-theme", current.theme);
  }

  function requestThemeSync() {
    syncNavTheme();
  }

  syncNavTheme();
  window.addEventListener("scroll", requestThemeSync, { passive: true });
  window.addEventListener("resize", requestThemeSync);
  window.addEventListener("load", requestThemeSync);
})();
(function () {
  var trigger = document.getElementById("mobile-menu-trigger");
  var panel = document.getElementById("mobile-menu-panel");
  var backdrop = document.getElementById("mobile-menu-backdrop");
  var mobileLinks = document.querySelectorAll("[data-mobile-nav-link]");
  if (!trigger || !panel || !backdrop) return;

  function moveFocusOutOfPanel() {
    if (!panel.contains(document.activeElement)) return;
    trigger.focus();
  }

  function setOpen(isOpen) {
    if (!isOpen) {
      moveFocusOutOfPanel();
    }

    trigger.setAttribute("aria-expanded", String(isOpen));
    trigger.setAttribute("aria-label", isOpen ? "Close navigation menu" : "Open navigation menu");
    panel.setAttribute("aria-hidden", String(!isOpen));
    backdrop.setAttribute("aria-hidden", String(!isOpen));
    if ("inert" in panel) {
      panel.inert = !isOpen;
    }
    if ("inert" in backdrop) {
      backdrop.inert = !isOpen;
    }
    document.body.classList.toggle("menu-open", isOpen);
    trigger.querySelector(".material-symbols-outlined").textContent = isOpen ? "close" : "menu";
    panel.classList.toggle("pointer-events-none", !isOpen);
    panel.classList.toggle("opacity-0", !isOpen);
    panel.classList.toggle("translate-x-full", !isOpen);
    backdrop.classList.toggle("pointer-events-none", !isOpen);
    backdrop.classList.toggle("opacity-0", !isOpen);

    if (isOpen) {
      var firstLink = panel.querySelector("[data-mobile-nav-link]");
      if (firstLink) {
        firstLink.focus();
      }
    }
  }

  setOpen(false);

  trigger.addEventListener("click", function () {
    setOpen(trigger.getAttribute("aria-expanded") !== "true");
  });

  backdrop.addEventListener("click", function () {
    setOpen(false);
  });

  mobileLinks.forEach(function (link) {
    link.addEventListener("click", function () {
      setOpen(false);
    });
  });

  window.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      setOpen(false);
    }
  });

  window.addEventListener("resize", function () {
    if (window.innerWidth >= 1200) {
      setOpen(false);
    }
  });
})();
(function () {
  /* 导航高亮与滚动：对齐老官网 HeaderNav（scrollIntoView + IntersectionObserver），避免 hash + scroll 计算在平滑滚动过程中把高亮打回上一节 */
  var desktopLinks = Array.prototype.slice.call(document.querySelectorAll("[data-section-link]"));
  var mobileSectionLinks = Array.prototype.slice.call(document.querySelectorAll("[data-mobile-section-link]"));
  var allSectionLinks = desktopLinks.concat(mobileSectionLinks);
  if (!allSectionLinks.length) return;

  // 仅按导航中可高亮的主区块计算激活态，避免后续模块干扰高亮
  var sectionIds = ["hero", "ai-diagnostics", "workflow", "data-security", "feedback", "downloads"];
  var sections = sectionIds
    .map(function (id) {
      return document.getElementById(id);
    })
    .filter(Boolean);

  var preferSmooth = !window.matchMedia || !window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function getActiveHashForSectionId(id) {
    if (id === "featured-products" || id === "shop-products") {
      return "#shop-products";
    }
    return "#" + id;
  }

  function updateLocationHash(id) {
    var nextHash = getActiveHashForSectionId(id);
    if (!nextHash || window.location.hash === nextHash) return;
    if (window.history && typeof window.history.pushState === "function") {
      window.history.pushState(null, "", nextHash);
      return;
    }
    window.location.hash = nextHash;
  }

  function syncActiveFromHash() {
    var h = window.location.hash;
    if (!h) return false;
    var hashId = h.slice(1);
    if (sectionIds.indexOf(hashId) === -1) return false;
    setActive(getActiveHashForSectionId(hashId));
    return true;
  }

  function getCurrentSectionFromScroll() {
    var header = document.getElementById("site-header");
    var offset = (header ? header.offsetHeight : 88) + 24;
    var current = sections[0];
    sections.forEach(function (section) {
      var sectionTop = section.getBoundingClientRect().top + window.scrollY;
      if (window.scrollY + offset >= sectionTop) {
        current = section;
      }
    });
    return current;
  }

  function syncActiveFromScroll() {
    var current = getCurrentSectionFromScroll();
    setActive(current ? getActiveHashForSectionId(current.id) : "#hero");
  }

  var scrollTicking = false;
  function requestScrollSync() {
    if (scrollTicking) return;
    scrollTicking = true;
    window.requestAnimationFrame(function () {
      scrollTicking = false;
      syncActiveFromScroll();
    });
  }

  function setActive(hash) {
    var normalized = hash && hash.indexOf("#") === 0 ? hash : "#hero";
    allSectionLinks.forEach(function (link) {
      var isActive = link.getAttribute("href") === normalized;
      if (link.hasAttribute("data-section-link")) {
        link.classList.toggle("nav-link--active", isActive);
        link.setAttribute("aria-current", isActive ? "page" : "false");
      }
      if (link.hasAttribute("data-mobile-section-link")) {
        link.classList.toggle("mobile-section-link--active", isActive);
        link.setAttribute("aria-current", isActive ? "page" : "false");
      }
    });
  }

  function scrollToSectionId(id) {
    var el = document.getElementById(id);
    if (!el) return;
    if (id === "hero") {
      window.scrollTo({
        top: 0,
        behavior: preferSmooth ? "smooth" : "auto"
      });
      return;
    }
    var header = document.getElementById("site-header");
    var headerOffset = (header ? header.offsetHeight : 88) + 12;
    var targetTop = el.getBoundingClientRect().top + window.scrollY - headerOffset;
    window.scrollTo({
      top: Math.max(0, targetTop),
      behavior: preferSmooth ? "smooth" : "auto"
    });
  }

  allSectionLinks.forEach(function (link) {
    link.addEventListener("click", function (e) {
      var href = link.getAttribute("href") || "";
      if (href.indexOf("#") !== 0) return;
      var id = href.slice(1);
      if (sectionIds.indexOf(id) === -1) return;
      e.preventDefault();
      updateLocationHash(id);
      scrollToSectionId(id);
    });
  });

  function syncInitialFromScroll() {
    syncActiveFromScroll();
  }

  syncInitialFromScroll();

  window.addEventListener("scroll", requestScrollSync, { passive: true });
  window.addEventListener("resize", requestScrollSync);
  window.addEventListener("load", requestScrollSync);

  window.addEventListener("hashchange", function () {
    if (!syncActiveFromHash()) {
      requestScrollSync();
    }
  });

  window.addEventListener("popstate", function () {
    if (!syncActiveFromHash()) {
      requestScrollSync();
    }
  });
})();
(function () {
  // 这一版尽量贴近老项目：页面启动后一次性读取 Shopify 商品，再把卡片内容灌进去。
  var cards = Array.prototype.slice.call(document.querySelectorAll("[data-shopify-product-card]"));
  if (!cards.length) return;

  var REDEEM_ONLY_VARIANT_ID = "53005947502899";
  var configuredBaseUrl = (document.body.getAttribute("data-shopify-base-url") || "").trim();
  var currentOrigin = (window.location.origin || "").replace(/\/$/, "");
  var isLocalPreview =
    /^(localhost|127\.0\.0\.1|0\.0\.0\.0)$/i.test(window.location.hostname || "") ||
    /^file:$/i.test(window.location.protocol || "");
  var hasExplicitStoreUrl = !!configuredBaseUrl && !/your-store\.myshopify\.com/i.test(configuredBaseUrl);
  var baseUrl = hasExplicitStoreUrl
    ? configuredBaseUrl.replace(/\/$/, "")
    : isLocalPreview
      ? ""
      : currentOrigin;

  function canUseShopifyLinks() {
    return !!baseUrl;
  }

  function buildProductUrl(handle) {
    if (!canUseShopifyLinks() || !handle) return "#featured-products";
    return baseUrl + "/products/" + encodeURIComponent(handle);
  }

  function buildProductJsonUrl(handle) {
    return buildProductUrl(handle) + ".js";
  }

  function buildProductsFeedUrl(limit) {
    if (!canUseShopifyLinks()) return "#featured-products";
    return baseUrl + "/products.json?limit=" + encodeURIComponent(String(limit));
  }

  function normalizePrice(value) {
    if (typeof value === "number") {
      return Number.isInteger(value) ? value / 100 : value;
    }
    if (typeof value === "string") {
      if (value.indexOf(".") !== -1) return parseFloat(value);
      var parsedInt = parseInt(value, 10);
      if (!isNaN(parsedInt)) return parsedInt / 100;
    }
    return null;
  }

  function formatMoney(value) {
    if (value == null || isNaN(value)) return null;
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: value % 1 === 0 ? 0 : 2
    }).format(value);
  }

  function stripHtml(html) {
    if (!html) return "";
    var temp = document.createElement("div");
    temp.innerHTML = html;
    return (temp.textContent || temp.innerText || "").replace(/\s+/g, " ").trim();
  }

  function truncateText(text, maxLength) {
    if (!text || text.length <= maxLength) return text;
    return text.slice(0, maxLength).replace(/\s+\S*$/, "") + "...";
  }

  function getPreferredVariant(product) {
    if (!product || !product.variants || !product.variants.length) return null;
    return (
      product.variants.find(function (variant) {
        return variant.available;
      }) || product.variants[0]
    );
  }

  function getProductImageUrl(product) {
    if (!product) return "";
    if (product.images && product.images.length) {
      if (typeof product.images[0] === "string") return product.images[0];
      if (product.images[0] && product.images[0].src) return product.images[0].src;
    }
    if (product.image && product.image.src) return product.image.src;
    return "";
  }

  function isRedeemOnlyProduct(product) {
    if (!product || !product.variants || !product.variants.length) return false;
    return product.variants.some(function (variant) {
      return String(variant.id) === REDEEM_ONLY_VARIANT_ID;
    });
  }

  function hasPurchasableVariant(product) {
    return !!getPreferredVariant(product);
  }

  function setCardImageState(card, hasLiveImage) {
    var imageEl = card.querySelector("[data-shopify-image]");
    var placeholderEl = card.querySelector("[data-shopify-image-placeholder]");
    if (imageEl) {
      imageEl.classList.toggle("hidden", !hasLiveImage);
    }
    if (placeholderEl) {
      placeholderEl.classList.toggle("hidden", !!hasLiveImage);
    }
  }

  function resetCardButtonState(card) {
    var buyNow = card.querySelector("[data-shopify-buy-now]");
    if (!buyNow) return;
    var defaultLabel = buyNow.getAttribute("data-default-label") || "Buy Now";
    buyNow.textContent = defaultLabel;
    buyNow.removeAttribute("aria-disabled");
  }

  function setCardLinks(card, handle) {
    var buyNow = card.querySelector("[data-shopify-buy-now]");
    var productUrl = buildProductUrl(handle);

    if (buyNow) {
      buyNow.href = productUrl;
    }
  }

  function setCardDisabledState(card, isDisabled) {
    var buyNow = card.querySelector("[data-shopify-buy-now]");
    if (buyNow) {
      buyNow.setAttribute("aria-disabled", isDisabled ? "true" : "false");
      buyNow.style.pointerEvents = isDisabled ? "none" : "";
      buyNow.style.opacity = isDisabled ? "0.55" : "";
    }
  }

  function setCardMessage(card, message, keepLinksEnabled) {
    var priceNoteEl = card.querySelector("[data-shopify-price-note]");
    setCardDisabledState(card, !keepLinksEnabled);
    resetCardButtonState(card);
    if (priceNoteEl) {
      priceNoteEl.textContent = message;
    }
  }

  function hydrateCard(card, product) {
    var handle = product.handle || "";
    var imageEl = card.querySelector("[data-shopify-image]");
    var titleEl = card.querySelector("[data-shopify-title]");
    var descriptionEl = card.querySelector("[data-shopify-description]");
    var priceEl = card.querySelector("[data-shopify-price]");
    var priceNoteEl = card.querySelector("[data-shopify-price-note]");
    var variant = getPreferredVariant(product);
    var imageUrl = getProductImageUrl(product);
    var descriptionText = truncateText(stripHtml(product.body_html || product.description || ""), 110);

    if (handle) {
      card.setAttribute("data-shopify-handle", handle);
    }

    if (imageEl && imageUrl) {
      imageEl.src = imageUrl;
      imageEl.alt = product.title || imageEl.alt;
      setCardImageState(card, true);
    } else {
      setCardImageState(card, false);
    }

    if (titleEl && product.title) {
      titleEl.textContent = product.title;
    }

    if (descriptionEl && descriptionText) {
      descriptionEl.textContent = descriptionText;
    }

    if (variant && variant.id) {
      card.setAttribute("data-shopify-variant-id", String(variant.id));
      setCardLinks(card, handle);
      setCardDisabledState(card, !variant.available);
    } else {
      card.setAttribute("data-shopify-variant-id", "");
      setCardLinks(card, handle);
      setCardDisabledState(card, true);
    }

    if (priceEl) {
      var priceSource = variant ? variant.price : product.price;
      var normalizedPrice = normalizePrice(priceSource);
      var formattedPrice = formatMoney(normalizedPrice);
      if (formattedPrice) {
        priceEl.textContent = formattedPrice;
      }
    }

    if (priceNoteEl) {
      priceNoteEl.textContent = variant && variant.available
        ? "Live product from Shopify. Buy Now opens the product page."
        : "Live product loaded from Shopify.";
    }

    resetCardButtonState(card);
    card.style.display = "";
  }

  function fetchJson(url) {
    return fetch(url, {
      headers: {
        Accept: "application/json"
      }
    }).then(function (response) {
      var redirectedPath = "";
      try {
        redirectedPath = response.url ? new URL(response.url).pathname : "";
      } catch (error) {
        redirectedPath = "";
      }
      if (response.redirected && /\/password\/?$/.test(redirectedPath)) {
        var passwordError = new Error("Storefront password protected");
        passwordError.code = "storefront_password";
        throw passwordError;
      }
      if (!response.ok) throw new Error("HTTP " + response.status);
      var contentType = response.headers.get("content-type") || "";
      if (contentType.indexOf("application/json") === -1) {
        var nonJsonError = new Error("Unexpected non-JSON response");
        nonJsonError.code = "non_json_response";
        throw nonJsonError;
      }
      return response.json();
    });
  }

  function fetchProduct(handle) {
    return fetchJson(buildProductJsonUrl(handle));
  }

  function fetchProducts(limit) {
    return fetchJson(buildProductsFeedUrl(limit)).then(function (payload) {
      return payload && Array.isArray(payload.products) ? payload.products : [];
    });
  }

  cards.forEach(function (card) {
    var buyNow = card.querySelector("[data-shopify-buy-now]");
    setCardImageState(card, false);
    if (buyNow) {
      buyNow.setAttribute("data-default-label", buyNow.textContent.trim() || "Buy Now");
    }
  });

  window.addEventListener("pageshow", function () {
    cards.forEach(function (card) {
      resetCardButtonState(card);
    });
  });

  if (!canUseShopifyLinks()) {
    return;
  }

  cards.forEach(function (card) {
    setCardMessage(card, "Loading live product from Shopify...", false);
  });

  var explicitCards = cards.filter(function (card) {
    return !!String(card.getAttribute("data-shopify-handle") || "").trim();
  });

  var autoCards = cards.filter(function (card) {
    return !String(card.getAttribute("data-shopify-handle") || "").trim();
  });

  explicitCards.forEach(function (card) {
    var handle = String(card.getAttribute("data-shopify-handle") || "").trim();
    fetchProduct(handle)
      .then(function (product) {
        hydrateCard(card, product);
      })
      .catch(function (error) {
        console.error("Failed to load Shopify product for", handle, error);
        if (error && error.code === "storefront_password") {
          setCardMessage(
            card,
            "This Shopify storefront is password-protected. Buy Now can still open the product page, but live price and checkout lookup stay blocked until the storefront password is removed.",
            true
          );
        } else {
          setCardMessage(card, "Could not load this Shopify product. Check the store domain and product handle.", true);
        }
      });
  });

  if (autoCards.length) {
    fetchProducts(Math.max(autoCards.length * 4, 12))
      .then(function (products) {
        var usableProducts = products.filter(function (product) {
          return !isRedeemOnlyProduct(product) && hasPurchasableVariant(product);
        });

        autoCards.forEach(function (card, index) {
          var product = usableProducts[index];
          if (!product) {
            setCardImageState(card, false);
            return;
          }
          hydrateCard(card, product);
        });
      })
      .catch(function (error) {
        console.error("Failed to load Shopify products feed", error);
        autoCards.forEach(function (card) {
          if (error && error.code === "storefront_password") {
            setCardMessage(
              card,
              "This Shopify storefront is password-protected. Product cards cannot auto-load until the storefront password is removed.",
              false
            );
          } else {
            setCardMessage(
              card,
              "Could not auto-load Shopify products. This usually means the storefront password is still on, or localhost preview cannot read the Shopify feed cross-origin.",
              false
            );
          }
        });
      });
  }

})();
(function () {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    document.querySelectorAll(".reveal, .reveal-card").forEach(function (el) {
      el.classList.add("is-visible");
    });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.08, rootMargin: "0px 0px -6% 0px" }
  );
  document.querySelectorAll(".reveal, .reveal-card").forEach(function (el) {
    observer.observe(el);
  });
})();
(function () {
  var form = document.getElementById("beyke-contact-form");
  if (!form) return;
  var submitBtn = form.querySelector('button[type="submit"]');
  var statusEl = document.getElementById("contact-form-status");
  var toastRoot = document.getElementById("beyke-contact-toast");
  var bodyEl = document.body;
  var globalApiBase = typeof window !== "undefined" ? window.INQUIRY_API_BASE : "";
  var apiBaseOverride = (bodyEl && bodyEl.getAttribute("data-inquiry-api-base")) || globalApiBase || "";
  var inquiryOverride = (bodyEl && bodyEl.getAttribute("data-inquiry-api-url")) || "";
  apiBaseOverride = String(apiBaseOverride || "").trim().replace(/\/+$/, "");
  inquiryOverride = String(inquiryOverride || "").trim();
  var API_BASE = apiBaseOverride || "https://www.beyke-monitoring.com/api";
  var INQUIRY_URL = inquiryOverride || API_BASE + "/official/inquiry";
  var IDENTITY_URL = API_BASE + "/official/identity";
  var ROLE_OPTIONS = [
    { identity: "I am a dental clinic" },
    { identity: "I am a distributor" },
    { identity: "I am a DSO / group practice" },
  ];
  var toastTimer = null;
  var emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var statusSelect = form.querySelector('[name="status"]');
  var timezoneInput = form.querySelector('[name="timezone"]');
  var timeInput1 = form.querySelector('[name="expected_time_1"]');
  var timeInput2 = form.querySelector('[name="expected_time_2"]');
  var timeInput3 = form.querySelector('[name="expected_time_3"]');

  function focusContactTimeField(name) {
    if (window.BeykeContactDatePickers && typeof window.BeykeContactDatePickers.focus === "function") {
      window.BeykeContactDatePickers.focus(name);
    }
  }

  function clearContactTimePickers() {
    if (window.BeykeContactDatePickers && typeof window.BeykeContactDatePickers.reset === "function") {
      window.BeykeContactDatePickers.reset();
    }
  }

  function isShanghaiQuietHoursBlockedValue(raw) {
    if (
      window.BeykeContactDatePickers &&
      typeof window.BeykeContactDatePickers.isShanghaiQuietHoursBlocked === "function"
    ) {
      return window.BeykeContactDatePickers.isShanghaiQuietHoursBlocked(raw);
    }
    return false;
  }

  function isMinimumLeadTimeBlockedValue(raw) {
    if (
      window.BeykeContactDatePickers &&
      typeof window.BeykeContactDatePickers.isMinimumLeadTimeBlocked === "function"
    ) {
      return window.BeykeContactDatePickers.isMinimumLeadTimeBlocked(raw);
    }

    var parsed = parseLocalDateTime(raw);
    return Number.isFinite(parsed) && parsed < Date.now() + 24 * 60 * 60 * 1000;
  }

  function isSundayBlockedValue(raw) {
    if (
      window.BeykeContactDatePickers &&
      typeof window.BeykeContactDatePickers.isSundayBlocked === "function"
    ) {
      return window.BeykeContactDatePickers.isSundayBlocked(raw);
    }
    return false;
  }

  function getTimezone() {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
    } catch (error) {
      return "UTC";
    }
  }

  function syncTimezoneFields() {
    var timezone = getTimezone();
    if (timezoneInput) timezoneInput.value = timezone;
    return timezone;
  }

  function shouldUseNgrokBypass(url) {
    return String(url || "").indexOf("ngrok") !== -1;
  }

  function buildHeaders(extra) {
    var headers = Object.assign(
      {
        Accept: "application/json",
        Platform: "shopify"
      },
      extra || {}
    );
    if (shouldUseNgrokBypass(INQUIRY_URL) || shouldUseNgrokBypass(IDENTITY_URL)) {
      headers["ngrok-skip-browser-warning"] = "true";
    }
    return headers;
  }

  function parseLocalDateTime(value) {
    var input = String(value || "").trim();
    if (!input) return null;

    var match = input.match(/^(\d{4})-(\d{2})-(\d{2})[T\s](\d{2}):(\d{2})/);
    if (!match) return NaN;

    var year = Number(match[1]);
    var month = Number(match[2]);
    var day = Number(match[3]);
    var hour = Number(match[4]);
    var minute = Number(match[5]);
    var date = new Date(year, month - 1, day, hour, minute, 0, 0);

    if (
      date.getFullYear() !== year ||
      date.getMonth() !== month - 1 ||
      date.getDate() !== day ||
      date.getHours() !== hour ||
      date.getMinutes() !== minute
    ) {
      return NaN;
    }

    return date.getTime();
  }

  function populateIdentityOptions(items) {
    if (!Array.isArray(items) || !items.length) return;
    if (window.BeykeContactIdentitySelect && typeof window.BeykeContactIdentitySelect.setOptions === "function") {
      window.BeykeContactIdentitySelect.setOptions(items);
      return;
    }
    if (!statusSelect) return;
    var currentValue = String(statusSelect.value || "").trim();
    statusSelect.value = currentValue;
  }

  function loadIdentityOptions() {
    if (!form) return Promise.resolve();
    populateIdentityOptions(ROLE_OPTIONS);
    return Promise.resolve();
  }

  function safeResetContactForm() {
    clearContactTimePickers();
    if (window.BeykeContactIdentitySelect && typeof window.BeykeContactIdentitySelect.reset === "function") {
      window.BeykeContactIdentitySelect.reset();
    } else if (statusSelect) {
      statusSelect.value = "";
    }

    ["full_name", "work_email", "company", "region", "message"].forEach(function (fieldName) {
      var field = form.querySelector('[name="' + fieldName + '"]');
      if (field) field.value = "";
    });

    syncTimezoneFields();
  }

  function showContactToast(message, variant) {
    if (!toastRoot) return;
    var panel = toastRoot.querySelector(".beyke-contact-toast__panel");
    var icon = toastRoot.querySelector(".beyke-contact-toast__icon");
    var text = toastRoot.querySelector(".beyke-contact-toast__text");
    if (!panel || !icon || !text) return;

    panel.classList.remove("beyke-contact-toast__panel--success", "beyke-contact-toast__panel--error");
    icon.classList.remove("beyke-contact-toast__icon--success", "beyke-contact-toast__icon--error");
    text.classList.remove("beyke-contact-toast__text--success", "beyke-contact-toast__text--error");

    if (variant === "success") {
      panel.classList.add("beyke-contact-toast__panel--success");
      icon.classList.add("beyke-contact-toast__icon--success");
      text.classList.add("beyke-contact-toast__text--success");
      icon.textContent = "check_circle";
    } else {
      panel.classList.add("beyke-contact-toast__panel--error");
      icon.classList.add("beyke-contact-toast__icon--error");
      text.classList.add("beyke-contact-toast__text--error");
      icon.textContent = "error";
    }
    text.textContent = message;

    toastRoot.hidden = false;
    toastRoot.removeAttribute("hidden");
    toastRoot.classList.remove("beyke-contact-toast--visible");
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        toastRoot.classList.add("beyke-contact-toast--visible");
      });
    });

    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastRoot.classList.remove("beyke-contact-toast--visible");
      setTimeout(function () {
        toastRoot.hidden = true;
        toastRoot.setAttribute("hidden", "");
      }, 360);
    }, 4200);
  }

  syncTimezoneFields();
  loadIdentityOptions().finally(function () {
    window.setTimeout(function () {
      loadIdentityOptions();
    }, 500);
  });
  window.addEventListener("focus", syncTimezoneFields);

  form.addEventListener("submit", function (e) {
    e.preventDefault();
    if (!submitBtn || submitBtn.disabled) return;

    var fullName = String(form.querySelector('[name="full_name"]').value || "").trim();
    var workEmail = String(form.querySelector('[name="work_email"]').value || "").trim();
    var status = String(form.querySelector('[name="status"]').value || "").trim();
    var region = String(form.querySelector('[name="region"]').value || "").trim();
    var timezone = syncTimezoneFields();
    var expectedTime1 = parseLocalDateTime(timeInput1 && timeInput1.value);
    var expectedTime2 = parseLocalDateTime(timeInput2 && timeInput2.value);
    var expectedTime3Raw = String((timeInput3 && timeInput3.value) || "").trim();
    var expectedTime3 = expectedTime3Raw ? parseLocalDateTime(expectedTime3Raw) : null;

    if (!fullName) {
      showContactToast("Please fill in this field — enter your full name.", "error");
      form.querySelector('[name="full_name"]').focus();
      return;
    }
    if (!workEmail) {
      showContactToast("Please fill in this field — enter your work email.", "error");
      form.querySelector('[name="work_email"]').focus();
      return;
    }
    if (!emailRe.test(workEmail)) {
      showContactToast("Please enter a valid email address.", "error");
      form.querySelector('[name="work_email"]').focus();
      return;
    }
    if (!status) {
      showContactToast("Please select your role.", "error");
      return;
    }
    if (!expectedTime1) {
      showContactToast("Please choose Expected Demo Time 1.", "error");
      focusContactTimeField("expected_time_1");
      return;
    }
    if (!Number.isFinite(expectedTime1)) {
      showContactToast("Expected Demo Time 1 must use a format like 2026-06-24 14:30.", "error");
      focusContactTimeField("expected_time_1");
      return;
    }
    if (!expectedTime2) {
      showContactToast("Please choose Expected Demo Time 2.", "error");
      focusContactTimeField("expected_time_2");
      return;
    }
    if (!Number.isFinite(expectedTime2)) {
      showContactToast("Expected Demo Time 2 must use a format like 2026-06-24 14:30.", "error");
      focusContactTimeField("expected_time_2");
      return;
    }
    if (expectedTime3Raw && !Number.isFinite(expectedTime3)) {
      showContactToast("Expected Demo Time 3 must use a format like 2026-06-24 14:30.", "error");
      focusContactTimeField("expected_time_3");
      return;
    }
    if (isMinimumLeadTimeBlockedValue(timeInput1 && timeInput1.value)) {
      showContactToast("Expected Demo Time 1 must be at least 24 hours from now.", "error");
      focusContactTimeField("expected_time_1");
      return;
    }
    if (isMinimumLeadTimeBlockedValue(timeInput2 && timeInput2.value)) {
      showContactToast("Expected Demo Time 2 must be at least 24 hours from now.", "error");
      focusContactTimeField("expected_time_2");
      return;
    }
    if (expectedTime3Raw && isMinimumLeadTimeBlockedValue(timeInput3 && timeInput3.value)) {
      showContactToast("Expected Demo Time 3 must be at least 24 hours from now.", "error");
      focusContactTimeField("expected_time_3");
      return;
    }
    if (isSundayBlockedValue(timeInput1 && timeInput1.value)) {
      showContactToast("Expected Demo Time 1 falls on Sunday. Please choose a weekday.", "error");
      focusContactTimeField("expected_time_1");
      return;
    }
    if (isSundayBlockedValue(timeInput2 && timeInput2.value)) {
      showContactToast("Expected Demo Time 2 falls on Sunday. Please choose a weekday.", "error");
      focusContactTimeField("expected_time_2");
      return;
    }
    if (expectedTime3Raw && isSundayBlockedValue(timeInput3 && timeInput3.value)) {
      showContactToast("Expected Demo Time 3 falls on Sunday. Please choose a weekday.", "error");
      focusContactTimeField("expected_time_3");
      return;
    }
    if (isShanghaiQuietHoursBlockedValue(timeInput1 && timeInput1.value)) {
      showContactToast("Expected Demo Time 1 is unavailable. Please choose another time.", "error");
      focusContactTimeField("expected_time_1");
      return;
    }
    if (isShanghaiQuietHoursBlockedValue(timeInput2 && timeInput2.value)) {
      showContactToast("Expected Demo Time 2 is unavailable. Please choose another time.", "error");
      focusContactTimeField("expected_time_2");
      return;
    }
    if (expectedTime3Raw && isShanghaiQuietHoursBlockedValue(timeInput3 && timeInput3.value)) {
      showContactToast("Expected Demo Time 3 is unavailable. Please choose another time.", "error");
      focusContactTimeField("expected_time_3");
      return;
    }
    if (!timezone) {
      showContactToast("We could not detect your timezone. Please refresh and try again.", "error");
      return;
    }
    if (expectedTime1 === expectedTime2) {
      showContactToast("Expected Demo Time 2 should be different from Time 1.", "error");
      focusContactTimeField("expected_time_2");
      return;
    }
    if (expectedTime3 && (expectedTime3 === expectedTime1 || expectedTime3 === expectedTime2)) {
      showContactToast("Expected Demo Time 3 should be different from the other selections.", "error");
      focusContactTimeField("expected_time_3");
      return;
    }

    var fd = new FormData(form);
    var payload = {
      fullName: fullName,
      workEmail: workEmail,
      companyClinic: String(fd.get("company") || "").trim(),
      countryRegion: region,
      status: status || null,
      message: String(fd.get("message") || "").trim(),
      expectedTime1: expectedTime1,
      expectedTime2: expectedTime2,
      expectedTime3: expectedTime3,
      timezone: timezone
    };

    if (statusEl) {
      statusEl.textContent = "";
    }

    var originalLabel = submitBtn.textContent;
    submitBtn.disabled = true;
    submitBtn.textContent = "Sending…";

    fetch(INQUIRY_URL, {
      method: "POST",
      headers: buildHeaders({
        "Content-Type": "application/json"
      }),
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        return res.text().then(function (t) {
          var json = {};
          try {
            json = t ? JSON.parse(t) : {};
          } catch (err) {
            json = {};
          }
          return { res: res, json: json };
        });
      })
      .then(function (r) {
        var json = r.json;
        var successMsg =
          "Thank you. We've received your inquiry and will reply within one to two business days.";

        if (json.code === 200) {
          showContactToast(successMsg, "success");
          if (statusEl) {
            statusEl.textContent = successMsg;
          }
          safeResetContactForm();
          return;
        }
        if (typeof json.code === "number" && json.code !== 200) {
          var errMsg =
            json.msg ||
            (json.code === 406
              ? "Please check your information and try again."
              : "Something went wrong. Please try again.");
          showContactToast(errMsg, "error");
          if (statusEl) {
            statusEl.textContent = errMsg;
          }
          return;
        }
        if (r.res.ok) {
          showContactToast(successMsg, "success");
          if (statusEl) {
            statusEl.textContent = successMsg;
          }
          safeResetContactForm();
          return;
        }
        throw new Error("HTTP " + r.res.status);
      })
      .catch(function () {
        var failMsg = "Could not send your message. Please try again or email us directly.";
        showContactToast(failMsg, "error");
        if (statusEl) {
          statusEl.textContent = failMsg;
        }
      })
      .finally(function () {
        submitBtn.disabled = false;
        submitBtn.textContent = originalLabel;
      });
  });
})();
(function () {
  var video = document.getElementById("hero-video");
  var btn = document.getElementById("hero-video-sound");
  var hoverSurface = document.querySelector("[data-hero-video-surface]");
  var heroSection = document.getElementById("hero");
  if (!video || !btn) return;

  var icon = btn.querySelector(".material-symbols-outlined");
  var label = btn.querySelector(".hero-video-sound-label");
  var useHeroPointerPlayback =
    !!hoverSurface &&
    typeof window.matchMedia === "function" &&
    window.matchMedia("(hover: hover) and (pointer: fine)").matches;

  function syncUi() {
    var on = !video.muted;
    btn.setAttribute("aria-pressed", on ? "true" : "false");
    btn.setAttribute("aria-label", on ? "Mute video" : "Turn on sound");
    if (icon) {
      icon.textContent = on ? "volume_up" : "volume_off";
    }
    if (label) {
      label.textContent = on ? "Mute" : "Sound on";
    }
  }

  function setPausedVisual(isPaused) {
    if (!hoverSurface) return;
    hoverSurface.classList.toggle("hero-video-frame--paused", !!isPaused);
  }

  function tryPlayMuted() {
    video.muted = true;
    video.volume = 1;
    var playAttempt = video.play();
    if (playAttempt && typeof playAttempt.catch === "function") {
      playAttempt.catch(function () {});
    }
    syncUi();
  }

  function initPlaybackWhenReady() {
    function run() {
      if (useHeroPointerPlayback) {
        video.muted = true;
        video.volume = 1;
        syncUi();
        video.pause();
        setPausedVisual(true);
      } else {
        tryPlayMuted();
      }
    }
    if (video.readyState >= 2) {
      run();
    } else {
      video.addEventListener("canplay", run, { once: true });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initPlaybackWhenReady);
  } else {
    initPlaybackWhenReady();
  }

  function playWhileOnHero() {
    if (!useHeroPointerPlayback) return;
    setPausedVisual(false);
    video.play().catch(function () {});
  }

  function pauseWhenLeavingHero() {
    if (!useHeroPointerPlayback) return;
    video.pause();
    setPausedVisual(true);
  }

  if (useHeroPointerPlayback && hoverSurface) {
    hoverSurface.addEventListener(
      "pointerenter",
      function (event) {
        if (event.pointerType && event.pointerType !== "mouse" && event.pointerType !== "pen") return;
        playWhileOnHero();
      },
      { passive: true }
    );

    hoverSurface.addEventListener(
      "pointerleave",
      function (event) {
        if (event.pointerType && event.pointerType !== "mouse" && event.pointerType !== "pen") return;
        pauseWhenLeavingHero();
      },
      { passive: true }
    );
  }

  if (heroSection && typeof IntersectionObserver === "function") {
    var heroIo = new IntersectionObserver(
      function (entries) {
        var e = entries[0];
        if (!e) return;
        if (!e.isIntersecting) {
          video.pause();
          setPausedVisual(true);
          return;
        }
        if (useHeroPointerPlayback) {
          if (
            hoverSurface &&
            typeof hoverSurface.matches === "function" &&
            hoverSurface.matches(":hover")
          ) {
            setPausedVisual(false);
            video.play().catch(function () {});
          }
        } else {
          setPausedVisual(false);
          video.play().catch(function () {});
        }
      },
      { threshold: 0 }
    );
    heroIo.observe(heroSection);
  }

  btn.addEventListener("click", function () {
    if (video.muted) {
      video.muted = false;
      video.volume = 1;
    } else {
      video.muted = true;
    }
    video.play().catch(function () {});
    syncUi();
  });

  video.addEventListener("volumechange", syncUi);
})();
(function () {
  // Mobile-only "show more" toggles: the button's parent is the collapsible block.
  var buttons = document.querySelectorAll("#ai-detection-library-module .ai-lib-more, #data-security-module .language-support-more");
  Array.prototype.forEach.call(buttons, function (button) {
    var block = button.parentElement;
    if (!block) return;
    var label = button.querySelector(".language-support-more__label") || button.querySelector("span");
    var icon = button.querySelector(".material-symbols-outlined");
    button.addEventListener("click", function () {
      var expanded = block.classList.toggle("is-expanded");
      button.setAttribute("aria-expanded", expanded ? "true" : "false");
      if (label) label.textContent = expanded ? button.getAttribute("data-label-less") : button.getAttribute("data-label-more");
      if (icon) icon.textContent = expanded ? "expand_less" : "expand_more";
    });
  });
  var cards = document.querySelectorAll("#data-security .data-security-card");
  Array.prototype.forEach.call(cards, function (card) {
    card.addEventListener("click", function () {
      if (!window.matchMedia("(max-width: 767px)").matches) return;
      card.classList.toggle("is-open");
    });
  });
})();
